import DoneIcon from "@mui/icons-material/Done";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TuneIcon from "@mui/icons-material/Tune";
import PeopleIcon from "@mui/icons-material/People";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { LoadingButton } from "./LoadingButton";

type Props = {
  onClick?(): void;
  loading?: boolean;
  disabled?: boolean;
  /** When provided, shows split button with dropdown; "Adjust tone" opens the picker at the given anchor. */
  onOpenAdjustTone?(anchorEl: HTMLElement): void;
  /** When provided, shows "Add contacts to CC" in the dropdown. */
  onAddOtherContactsToCc?(): void;
};

export function CompleteButton({
  onClick,
  loading = false,
  disabled = false,
  onOpenAdjustTone,
  onAddOtherContactsToCc,
}: Props) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchor);

  if (onOpenAdjustTone || onAddOtherContactsToCc) {
    return (
      <>
        <ButtonGroup variant="contained" fullWidth sx={{ "& .MuiButtonGroup-grouped": { minWidth: 0 } }}>
          <LoadingButton
            fullWidth
            loading={loading}
            loadingPosition="end"
            endIcon={<DoneIcon />}
            onClick={onClick}
            disabled={disabled}
            sx={{ flex: 1, minWidth: 0 }}
          >
            Complete
          </LoadingButton>
          <Button
            aria-controls={menuOpen ? "complete-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? "true" : undefined}
            onClick={(e) => setMenuAnchor(e.currentTarget)}
            disabled={disabled}
            sx={{
              minWidth: 32,
              width: 32,
              maxWidth: 32,
              px: 0,
              "& .MuiSvgIcon-root": { fontSize: 18 },
            }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Menu
          id="complete-menu"
          anchorEl={menuAnchor}
          open={menuOpen}
          onClose={() => setMenuAnchor(null)}
          MenuListProps={{ "aria-labelledby": "complete-button" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          {onOpenAdjustTone && (
            <MenuItem
              onClick={() => {
                const anchor = menuAnchor;
                setMenuAnchor(null);
                if (anchor) onOpenAdjustTone(anchor);
              }}
            >
              <ListItemIcon>
                <TuneIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Adjust tone" />
            </MenuItem>
          )}
          {onAddOtherContactsToCc && (
            <MenuItem
              onClick={() => {
                setMenuAnchor(null);
                onAddOtherContactsToCc();
              }}
            >
              <ListItemIcon>
                <PeopleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Add contacts to CC" />
            </MenuItem>
          )}
        </Menu>
      </>
    );
  }

  return (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      fullWidth={true}
      loading={loading}
      loadingPosition="end"
      endIcon={<DoneIcon />}
      disabled={disabled}
    >
      Complete
    </LoadingButton>
  );
}
